var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useEffect, useState } from "react";
import { defaultLiquidityGaugeV5PoolData, } from "../models/staking";
import { impersonateAddress } from "../utils/development";
import { usePendingTransactions } from "./pendingTransactionsContext";
import { useWeb3Context } from "./web3Context";
import { isProduction } from "../utils/env";
import { isEthNetwork, VaultLiquidityMiningMap, } from "../constants/constants";
import { BigNumber } from "@ethersproject/bignumber";
import { getLiquidityGaugeV5 } from "./useLiquidityGaugeV5";
import useLiquidityTokenMinter from "./useLiquidityTokenMinter";
import useLiquidityGaugeController from "./useLiquidityGaugeController";
import { constants } from "ethers";
import { calculateClaimableRbn } from "../utils/governanceMath";
import useWeb3Wallet from "./useWeb3Wallet";
import { getVaultContract } from "./useVaultContract";
var useFetchLiquidityGaugeV5Data = function () {
    var _a = useWeb3Wallet(), active = _a.active, web3Account = _a.account, ethereumProvider = _a.ethereumProvider, chainId = _a.chainId;
    var provider = useWeb3Context().provider;
    var account = impersonateAddress ? impersonateAddress : web3Account;
    var transactionsCounter = usePendingTransactions().transactionsCounter;
    var minterContract = useLiquidityTokenMinter();
    var gaugeControllerContract = useLiquidityGaugeController();
    var _b = useState(defaultLiquidityGaugeV5PoolData), data = _b[0], setData = _b[1];
    var _c = useState(0), setMulticallCounter = _c[1];
    var doMulticall = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentCounter, minterResponsePromises, _a, rate, periodEndTime, gaugeResponsesPromises, guageResponses;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (
                    // If a wallet is connected and its NOT ETH, dont fetch
                    (chainId && !isEthNetwork(chainId)) ||
                        !minterContract ||
                        !gaugeControllerContract) {
                        setData(__assign(__assign({}, defaultLiquidityGaugeV5PoolData), { loading: false }));
                        return [2 /*return*/];
                    }
                    if (!isProduction()) {
                        console.time("Liquidity Gauge V5 Data Fetch"); // eslint-disable-line
                    }
                    setMulticallCounter(function (counter) {
                        currentCounter = counter + 1;
                        return currentCounter;
                    });
                    // TODO: Make this chain agnostic, for now we only enable when user connected to ETH
                    // Make sure loading is turned on before fetching
                    setData(__assign(__assign({}, defaultLiquidityGaugeV5PoolData), { loading: true }));
                    minterResponsePromises = Promise.all([
                        minterContract.rate(),
                        gaugeControllerContract.time_total(),
                    ]);
                    return [4 /*yield*/, minterResponsePromises];
                case 1:
                    _a = _b.sent(), rate = _a[0], periodEndTime = _a[1];
                    gaugeResponsesPromises = Promise.all(Object.keys(VaultLiquidityMiningMap.lg5).map(function (_vault) { return __awaiter(void 0, void 0, void 0, function () {
                        var vault, lg5Contract, vaultContract, period, isKilled, unconnectedPromises, promises, _a, poolSize, workingBalances, workingSupply, relativeWeight, 
                        // Calculate claimable rbn
                        periodTimestamp, integrateInvSupply, futureEpochTime, inflationRate, currentStake, unstakedBalance, integrateFraction, claimedRbn, 
                        // Also to calculate claimable rbn
                        integrateInvSupplyOf, 
                        // Block timestamp of the last time integrate_checkpoint was called
                        integrateCheckpointOf, vaultAddress, claimableRbn, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    vault = _vault;
                                    lg5Contract = getLiquidityGaugeV5(ethereumProvider || provider, vault, active);
                                    vaultContract = getVaultContract(ethereumProvider || provider, vault, active);
                                    return [4 /*yield*/, lg5Contract.period()];
                                case 1:
                                    period = _c.sent();
                                    return [4 /*yield*/, lg5Contract.is_killed()];
                                case 2:
                                    isKilled = _c.sent();
                                    unconnectedPromises = [
                                        lg5Contract.totalSupply(),
                                        lg5Contract.working_balances(account !== null && account !== void 0 ? account : constants.AddressZero),
                                        lg5Contract.working_supply(),
                                        gaugeControllerContract["gauge_relative_weight(address)"](VaultLiquidityMiningMap.lg5[vault]),
                                        // To calculate claimable rbn
                                        lg5Contract.period_timestamp(period),
                                        lg5Contract.integrate_inv_supply(period),
                                        lg5Contract.future_epoch_time(),
                                        lg5Contract.inflation_rate(),
                                    ];
                                    promises = unconnectedPromises.concat(account
                                        ? [
                                            lg5Contract.balanceOf(account),
                                            vaultContract.shares(account),
                                            lg5Contract.integrate_fraction(account),
                                            minterContract.minted(account, VaultLiquidityMiningMap.lg5[vault]),
                                            // To calculate claimable rbn
                                            lg5Contract.integrate_inv_supply_of(account),
                                            // Block timestamp of the last time integrate_checkpoint was called
                                            lg5Contract.integrate_checkpoint_of(account),
                                        ]
                                        : [
                                            // Default value when not connected
                                            Promise.resolve(BigNumber.from(0)),
                                            Promise.resolve(BigNumber.from(0)),
                                            Promise.resolve(BigNumber.from(0)),
                                            Promise.resolve(BigNumber.from(0)),
                                            Promise.resolve(BigNumber.from(0)),
                                            Promise.resolve(BigNumber.from(0)),
                                        ]);
                                    return [4 /*yield*/, Promise.all(
                                        // Default to 0 when error
                                        promises.map(function (p) { return p.catch(function (e) { return BigNumber.from(0); }); }))];
                                case 3:
                                    _a = _c.sent(), poolSize = _a[0], workingBalances = _a[1], workingSupply = _a[2], relativeWeight = _a[3], periodTimestamp = _a[4], integrateInvSupply = _a[5], futureEpochTime = _a[6], inflationRate = _a[7], currentStake = _a[8], unstakedBalance = _a[9], integrateFraction = _a[10], claimedRbn = _a[11], integrateInvSupplyOf = _a[12], integrateCheckpointOf = _a[13];
                                    vaultAddress = VaultLiquidityMiningMap.lg5[vault];
                                    if (!vaultAddress) return [3 /*break*/, 5];
                                    return [4 /*yield*/, calculateClaimableRbn({
                                            currentDate: new Date(),
                                            periodTimestamp: periodTimestamp.toNumber(),
                                            integrateInvSupply: integrateInvSupply,
                                            integrateFraction: integrateFraction,
                                            integrateInvSupplyOf: integrateInvSupplyOf,
                                            futureEpochTime: futureEpochTime.toNumber(),
                                            inflation_rate: inflationRate,
                                            minterRate: rate,
                                            isKilled: isKilled,
                                            workingSupply: workingSupply,
                                            workingBalance: workingBalances,
                                            mintedRBN: claimedRbn,
                                            gaugeContractAddress: vaultAddress,
                                            gaugeControllerContract: gaugeControllerContract,
                                        })];
                                case 4:
                                    _b = _c.sent();
                                    return [3 /*break*/, 6];
                                case 5:
                                    _b = BigNumber.from(0);
                                    _c.label = 6;
                                case 6:
                                    claimableRbn = _b;
                                    return [2 /*return*/, {
                                            vault: vault,
                                            poolSize: poolSize,
                                            workingBalances: workingBalances,
                                            workingSupply: workingSupply,
                                            relativeWeight: relativeWeight,
                                            currentStake: currentStake,
                                            unstakedBalance: unstakedBalance,
                                            claimedRbn: claimedRbn,
                                            claimableRbn: claimableRbn,
                                            integrateCheckpointOf: integrateCheckpointOf,
                                        }];
                            }
                        });
                    }); }));
                    return [4 /*yield*/, gaugeResponsesPromises];
                case 2:
                    guageResponses = _b.sent();
                    setMulticallCounter(function (counter) {
                        if (counter === currentCounter) {
                            setData(function (prev) { return ({
                                responses: Object.fromEntries(guageResponses.map(function (_a) {
                                    var vault = _a.vault, relativeWeight = _a.relativeWeight, claimableRbn = _a.claimableRbn, response = __rest(_a, ["vault", "relativeWeight", "claimableRbn"]);
                                    return [
                                        vault,
                                        __assign(__assign(__assign({}, prev.responses[vault]), { claimableRbn: claimableRbn, poolRewardForDuration: rate
                                                // Rate is RBN/second. There is 86400 is seconds in a day. Each period is 1 week.
                                                .mul(86400 * 7)
                                                .mul(relativeWeight)
                                                // Relative weight is in percentage, but normalized to 1e18, so we need to divide it
                                                .div(BigNumber.from(10).pow(18)), periodEndTime: parseInt(periodEndTime.toString()) }), response),
                                    ];
                                })),
                                loading: false,
                            }); });
                        }
                        return counter;
                    });
                    if (!isProduction()) {
                        console.timeEnd("Liquidity Gauge V5 Data Fetch"); // eslint-disable-line
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [
        account,
        active,
        ethereumProvider,
        gaugeControllerContract,
        minterContract,
        provider,
        chainId,
    ]);
    useEffect(function () {
        doMulticall();
    }, [doMulticall, transactionsCounter]);
    return data;
};
export default useFetchLiquidityGaugeV5Data;
//# sourceMappingURL=useFetchLiquidityGaugeV5Data.js.map